import { Capacitor } from '@capacitor/core'

export const isApp = Capacitor.isNativePlatform() //|| process.env.runningInCapacitor
export const isWebsite = !Capacitor.isNativePlatform()
